module.exports = __webpack_public_path__ + "static/7-6c47ac53db80ae33feddd58aa4b6fb5b.jpg";